export const projectsData = [
  {
    id: 1,
    title: "API MovieDb with React",
    date: "Mars 2023",
    languages: ["React", "Json"],
    infos:
      "Une petite utilisation des hooks avec React. Dans le cadre de la formation Ibm Académie. Ceci est la version 1.0. D'autres features sont en préparation.",
    img: "./assets/img/react-apidbmovie.png",
    link: "https://pierreolivierb-apidbmovie.netlify.app/",
  },
  {
    id: 2,
    title: "Lecteur Audio",
    date: "Février 2023",
    languages: ["Js", "JSon", "SaSS"],
    infos: "Voici la nouvelle version du lecteur 1an plus tard",
    img: "./assets/img/gameboy_player.png",
    link: "https://baudino.needemand.com/ibm/player-boy/index.html",
  },
  {
    id: 3,
    title: "TchatBot",
    date: "Mars 2023",
    languages: ["Js", "html", "Css"],
    infos:
      "Un lecteur audio avec commande vocale. Peut être vous répondra-t-il à plus de questions...",
    img: "./assets/img/tchat_bot.png",
    link: "https://baudino.needemand.com/ibm/voice/index.html",
  },
  {
    id: 4,
    title: "Portfolio",
    date: "Janvier 2022",
    languages: ["Html", "Css", "Js"],
    infos:
      "Voici mon premier site portfolio réaliser dans le cadre de ma formation avec le Greta.",
    img: "./assets/img/first_portfolio.png",
    link: "https://pierre-olivierb.github.io/index.html",
  },
  {
    id: 5,
    title: "API",
    date: "Avril 2022",
    languages: ["Php", "Json"],
    infos:
      "Cette fois nous voilà devant une api créée from-scratch. Après `/API/` nous pouvons ajouter : `ingredients/cookies`, `content/muffin`, `recipes/`",
    img: "./assets/img/api_test.png",
    link: "https://baudino.needemand.com/API_TEST/API/search/chocolat",
  },
];
